import React from 'react';
import { useLoader } from '@react-three/fiber';
import { TextureLoader } from 'three';
export var ReactThreeFiberImageMaker = function (_a) {
    var level = _a.level, imageUrl = _a.imageUrl;
    var texture = useLoader(TextureLoader, imageUrl, undefined, function (err) {
        console.error("Error loading image from ".concat(imageUrl, ":"), err);
    });
    if (!texture) {
        console.error("Failed to create image texture with ".concat(imageUrl, "."));
        return React.createElement(React.Fragment, null);
    }
    var image = level.images[0];
    var scale = image.scale;
    var imgW = texture.image.width * scale;
    var imgH = texture.image.height * scale;
    if (Math.abs(image.yaw) > 0.01) {
        return (React.createElement("group", { position: [image.x_offset, image.y_offset, 0], rotation: [0, 0, image.yaw] },
            React.createElement("mesh", { position: [imgW / 2, -imgH / 2, 0] },
                React.createElement("planeGeometry", { attach: "geometry", args: [imgW, imgH] }),
                React.createElement("meshBasicMaterial", { attach: "material", map: texture, toneMapped: false }))));
    }
    return (React.createElement("mesh", { position: [imgW / 2 + image.x_offset, -imgH / 2 + image.y_offset, 0] },
        React.createElement("planeGeometry", { attach: "geometry", args: [imgW, imgH] }),
        React.createElement("meshBasicMaterial", { attach: "material", map: texture, toneMapped: false })));
};
